var map = {
	"./account.svg": 60337,
	"./account_selected.svg": 13255,
	"./arrow_right.svg": 31020,
	"./checkbox.svg": 54679,
	"./checkbox_checked.svg": 53077,
	"./close_btn.svg": 23949,
	"./completed.svg": 13615,
	"./completed_selected.svg": 47349,
	"./delete.svg": 37253,
	"./delivering.svg": 10689,
	"./delivering_selected.svg": 36183,
	"./delivery.svg": 40620,
	"./drink.svg": 12554,
	"./drop_down.svg": 19430,
	"./eye_close.svg": 51338,
	"./eye_open.svg": 12854,
	"./faq.svg": 32228,
	"./home.svg": 12777,
	"./home_selected.svg": 71823,
	"./invoice.svg": 50245,
	"./lang.svg": 50448,
	"./menu.svg": 18001,
	"./menu_selected.svg": 45607,
	"./minus_btn.svg": 32793,
	"./notify.svg": 8111,
	"./ordered.svg": 27935,
	"./ordered_selected.svg": 68901,
	"./orders.svg": 60927,
	"./orders_selected.svg": 10693,
	"./phone.svg": 62296,
	"./pickup.svg": 64208,
	"./plus_btn.svg": 9089,
	"./point.svg": 27054,
	"./position.svg": 11917,
	"./preparing.svg": 90784,
	"./preparing_selected.svg": 60332,
	"./profile.svg": 35107,
	"./ready.svg": 5481,
	"./ready_selected.svg": 47887,
	"./rewards.svg": 63208,
	"./rewards_selected.svg": 20132,
	"./search.svg": 41792,
	"./selected_mark.svg": 20509,
	"./step_arrow.svg": 26520,
	"./switch.svg": 99656,
	"./toast_fail.svg": 23440,
	"./voucher.svg": 24374,
	"./wallet.svg": 21235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;